import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.177 19H4.355a.865.865 0 0 1-.854-.873v-6.502H1.855A.865.865 0 0 1 1 10.752V7.966c0-.481.383-.873.855-.873H3.5V5.698c0-1.384.425-2.56 1.23-3.404C5.537 1.448 6.666 1 7.994 1l2.152.004c.47 0 .853.392.853.873v2.586a.865.865 0 0 1-.854.874h-1.45c-.441 0-.553.09-.578.118-.04.046-.086.176-.086.536v1.102h2.005c.15 0 .297.038.423.11a.88.88 0 0 1 .44.763l-.002 2.786a.865.865 0 0 1-.854.873H8.032v6.502a.865.865 0 0 1-.855.873Z",
      "fill-rule": "nonzero",
      stroke: "currentColor",
      "stroke-width": "1.5",
      fill: "none",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }